import React, { useEffect, useLayoutEffect, useState } from 'react';

import PropTypes from 'prop-types';
import $ from "jquery";
import axios from "axios";

import { createContext, useContext, useReducer } from "react";
import { HotelsReducer } from "./reducers/hotels/reducers";
import { CarsReducer } from "./reducers/cars/reducers";
import { AirfareReducer } from "./reducers/airfare/reducers";
import {
    getWhitelabelFromMemory,
    setWhitelabelInMemory,
    subscribeSessionMemory,
} from "../lib/sharedSessionMemory";

import {initial_time, initial_guests, data_travellers, initial_dates, initial_date} from "utils";

const INITIAL_STATE_HOTEL = {
    locationSearchHotel: {},
    datesSearchHotel: initial_date,
    guestsSearchHotel: initial_guests,
    offersHotel: 'points',
    hotelsList: [],
    hotel: {},
    room: {},
    travellers: data_travellers
}

 const INITIAL_STATE_CAR = {
    locationPickupCar: {},
    locationDropOffCar: {},
    returnSameLocalCar: true,
    datesSearchCar: initial_date,
    timeSearchCar: initial_time,
    offersCar: 'points',
    car: {},
    conductor: {}
}

const INITIAL_STATE_AIRFARE = {
    locationDeparture: {},
    locationArrival: {},
    onlyDeparture: false,
    datesSearchAirfare: initial_date,
    offersAirfare: 'points',
    classAirfare: 'economic',
    numberOfPassengers: {
        adults: 1,
        children: 0,
        baby: 0
    }
}

const FALLBACK_WHITELABEL = Object.freeze({
    uuid: null,
    channel_id: null,
    name: "",
    logo_url: "",
    header_color: "#000000",
    button_primary_color: "#FF0000",
    button_secondary_color: "#00FF00",
    text_primary_color: "#333333",
    text_secondary_color: "#777777",
    payment_mode: "money",
    faq: "",
    is_active: true,
});

function readWhitelabelStateFromMemory() {
    return getWhitelabelFromMemory() || FALLBACK_WHITELABEL;
}

export const AppContext = createContext('')

export const AppProvider = ({ children }) => {

    const [hotelState, hotelDispatch] = useReducer(
        HotelsReducer,
        INITIAL_STATE_HOTEL
    )

    const [carState, carDispatch] = useReducer(
        CarsReducer,
        INITIAL_STATE_CAR
    )

    const [airfareState, airfareDispatch] = useReducer(
        AirfareReducer,
        INITIAL_STATE_AIRFARE
    )

    const [whitelabel, setWhitelabel] = useState(readWhitelabelStateFromMemory);

    const setWhitelabelShared = (value) => {
        setWhitelabelInMemory(value);
        setWhitelabel(readWhitelabelStateFromMemory());
    };

    useLayoutEffect(() => {
        setWhitelabel(readWhitelabelStateFromMemory());
    }, []);

    useEffect(() => {
        const unsubscribe = subscribeSessionMemory((memory) => {
            setWhitelabel(memory.whitelabel || FALLBACK_WHITELABEL);
        });
        return unsubscribe;
    }, []);

    return (
        <AppContext.Provider value={{
            hotelState,
            hotelDispatch,
            carState,
            carDispatch,
            airfareState,
            airfareDispatch,
            whitelabel, 
            setWhitelabel: setWhitelabelShared
        }}>
            {children}
        </AppContext.Provider>
    )
}

export const useApp = () => useContext(AppContext);

AppProvider.propTypes = {
    children: PropTypes.node.isRequired,
};